/*!
 * Transforme Tabs
 */
var $ = require('jquery');

$(function () {
	var Tabs = {

		init: function () {
			this.bindUIfunctions();
			this.pageLoadCorrectTab();
		},

		bindUIfunctions: function () {

			// Delegation
			$(document)
				.on("click", ".tab-nav a[href^='#']:not('.active')", function (event) {
					Tabs.changeTab(this.hash);
					event.preventDefault();
				})
				.on("click", ".tab-nav a.active", function (event) {
					var bodyWidth = $("body").outerWidth();
					if (bodyWidth < 975) {
						Tabs.toggleMobileMenu(event, this);
					}
					event.preventDefault();
				})
				.on("click", ".routes-nav a.active", function (event) {
					var bodyWidth = $("body").outerWidth();
					if (bodyWidth < 975) {
						Tabs.toggleMobileMenu(event, this);
					}
					event.preventDefault();
				});
		},

		changeTab: function (hash) {

			var anchor = $('.tab-nav a[href="' + hash + '"]'); //$('[href="#'+ hash +'"]');
			var div = $(hash);

			// activate correct anchor (visually)
			// anchor.addClass("active").parent().siblings().find("a").removeClass("active");
			anchor.parent().siblings().find("a").removeClass("active");
			anchor.addClass("active");


			// activate correct div (visually)
			// div.addClass("active").siblings().removeClass("active");
			div.siblings().removeClass("active");
			div.addClass("active");

			// update URL, no history addition
			// You'd have this active in a real situation, but it causes issues in an <iframe> (like here on CodePen) in Firefox. So commenting out.
			// window.history.replaceState("", "", hash);

			// Close menu, in case mobile
			anchor.closest("ul").removeClass("open");

		},

		// If the page has a hash on load, go to that tab
		pageLoadCorrectTab: function () {
			this.changeTab(document.location.hash);
		},

		toggleMobileMenu: function (event, el) {
			$(el).closest("li").prependTo($(el).closest("ul"));
			$(el).closest("ul").toggleClass("open");
		}
	};

	// Initialise
	Tabs.init();
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/transformeTabs.js